import React from 'react';

import styles from './ApplicationCard.module.scss';

export const ApplicationCard = ({
  description,
  imageSrc,
  headerColor,
  title
}: {
  description: string;
  imageSrc: string;
  headerColor: string;
  title: string;
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header} style={{ backgroundColor: headerColor }} />
      <img className={styles.image} src={imageSrc} />
      <div className={styles.textContainer}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};
